export const propertyConstants = {
  HISTORY_PUSH: 'ADD_HISTORY_PUSH',
  HISTORY_POP: 'ADD_HISTORY_POP',
  HISTORY_RESET: 'ADD_HISTORY_RESET',
  HISTORY_KEEP: 'ADD_HISTORY_KEEP',

  UPDATE_FUNCTION:'DEFINE_UPDATE_FUNCTION'
};